import cssTransition from 'ember-css-transitions/modifiers/css-transition';
import { t } from 'ember-intl';
import lowerCase from 'lodash/lowerCase';
import BvSpinner from 'volta/components/bv-spinner';
import classNames from 'volta/helpers/class-names';

import type { TOC } from '@ember/component/template-only';
import type { IResourceName } from 'volta/models/base-model';

interface BvCollectionLoaderSignature {
  Args: {
    absolute?: boolean;
    resourceName?: IResourceName;
  };
  Element: HTMLDivElement;
}

const BvCollectionLoaderComponent: TOC<BvCollectionLoaderSignature> = <template>
  <div
    class={{classNames 'bv-collection-loader' (if @absolute 'bv-collection-loader--absolute')}}
    {{cssTransition 'bv-collection-loader'}}
    ...attributes
  >
    <div class='bv-collection-loader-panel'>
      <div class='bv-collection-loader-panel-row'>
        <BvSpinner @size='sm' @intent='primary' />
        <span class='bv-collection-loader-panel-text'>
          {{t
            'bvList.loading'
            resourceNamePlural=(lowerCase (t (if @resourceName @resourceName.plural 'items')))
          }}
        </span>
      </div>
    </div>
  </div>
</template>;

export default BvCollectionLoaderComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvCollectionLoader: typeof BvCollectionLoaderComponent;
    'bv-collection-loader': typeof BvCollectionLoaderComponent;
  }
}
